import { Outlet } from "react-router-dom";

function SimpleLayout() {
  // TODO: 获取token

  return <Outlet />
}

export default SimpleLayout;
